import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { StandardContent } from "@/components/App";
import { useAuth } from "@/components/Auth";
import Button from "@/components/Button";
import ErrorText from "@/components/ErrorText";
import Header from "@/components/Header";
import { Input } from "@/components/Input";
import Loader from "@/components/Loader";
import { SubHeader } from "@/components/SubHeader";
import { ErrorMessages } from "@/constants/messages";
import { PageRoute } from "@/constants/pages";
import { useUpdateCommunicationSettingsMutation } from "@/hooks/user";
import { isSet } from "@/utils/helpers";

export function EmailUnsubPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const unSubMutation = useUpdateCommunicationSettingsMutation();
  const reSubMutation = useUpdateCommunicationSettingsMutation();

  useEffect(() => {
    if (!user) {
      return;
    }

    unSubMutation.mutate({
      payload: {
        email: {
          schedule: false,
        },
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function reSub() {
    reSubMutation.mutate({
      payload: {
        email: {
          schedule: true,
        },
      },
    });
  }

  if (!isSet(user)) {
    navigate(PageRoute.HOME);
    return;
  }

  if (unSubMutation.isPending || reSubMutation.isPending) {
    return (
      <StandardContent>
        <Loader />
      </StandardContent>
    );
  }

  if (unSubMutation.isError || reSubMutation.isError) {
    return (
      <StandardContent>
        <ErrorText>{ErrorMessages.GENERIC}</ErrorText>
      </StandardContent>
    );
  }

  if (reSubMutation.data) {
    return (
      <StandardContent>
        <div className={"flex grow flex-col"}>
          <Header className="mb-4 text-xl" as="h2">
            Welcome Back!
          </Header>
          <SubHeader className={"mb-4"}>
            You are subscribed to appointment notification emails.
          </SubHeader>
        </div>
      </StandardContent>
    );
  }

  if (!unSubMutation.data) {
    return null;
  }

  return (
    <StandardContent>
      <div className={"flex grow flex-col"}>
        <Header className="mb-2 text-xl" as="h2">
          We are sad to see you go!
        </Header>
        <SubHeader className={"mb-4 whitespace-pre-line"}>
          You are now unsubscribed from appointment notification emails.
        </SubHeader>
        <Input className={"mb-4 text-left"} disabled value={user.email} />
        <Button onClick={reSub}>Resubscribe</Button>
      </div>
    </StandardContent>
  );
}
